(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ode-currency-prompt"] && !Shopify.designMode) return;
  try {
    (() => {
    const prompt = document.querySelector('[data-ode-currency-prompt]');
    if (!prompt || typeof prompt.show !== 'function' || window.Shopify?.designMode) return;

    const storageKey = 'ode-currency-prompt';
    const detectedKey = 'ode-detected-country';

    const answered = () => {
      try {
        const saved = JSON.parse(localStorage.getItem(storageKey) || 'null');
        return Boolean(saved && saved.until > Date.now());
      } catch (error) {
        return false;
      }
    };

    const remember = (answer, days) => {
      try {
        localStorage.setItem(storageKey, JSON.stringify({ answer, until: Date.now() + days * 86400000 }));
      } catch (error) {
        // Browsing still works with storage disabled.
      }
    };

    // One lookup per visit: the IP does not change between pages.
    const detectCountry = async () => {
      try {
        const cached = sessionStorage.getItem(detectedKey);
        if (cached !== null) return cached;
      } catch (error) {
        // Fall through to the lookup.
      }
      const root = window.Shopify?.routes?.root || '/';
      const current = encodeURIComponent(window.Shopify?.country || '');
      const response = await fetch(`${root}browsing_context_suggestions.json?country[enabled]=true&country[exclude]=${current}`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return '';
      const data = await response.json();
      const code = data?.detected_values?.country?.handle || '';
      try {
        sessionStorage.setItem(detectedKey, code);
      } catch (error) {
        // Ask again next page; nothing else depends on it.
      }
      return code;
    };

    const close = (answer, days) => {
      remember(answer, days);
      if (!prompt.open) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        prompt.close();
        return;
      }
      prompt.classList.add('is-closing');
      window.setTimeout(() => {
        prompt.classList.remove('is-closing');
        prompt.close();
      }, 180);
    };

    // Wait out anything already on screen, the signup invitation included.
    const open = () => {
      if (answered()) return;
      if (document.hidden || document.querySelector('dialog[open]')) {
        window.setTimeout(open, 1000);
        return;
      }
      prompt.show();
    };

    const run = async () => {
      if (answered()) return;
      const select = document.querySelector('[data-ode-localization-select]');
      if (!select?.form) return;

      let detected = '';
      try {
        detected = await detectCountry();
      } catch (error) {
        return;
      }

      const options = [...select.options];
      const target = options.find((option) => option.value === detected);
      const current = options.find((option) => option.value === window.Shopify?.country) || select.selectedOptions[0];
      if (!target || !current || target === current) return;

      // A Belgian browsing in euros as a German is already in the right money;
      // this is only about currency.
      const currencyCode = (option) => (option.dataset.currency || '').split(' ')[0];
      if (currencyCode(target) === currencyCode(current)) return;

      prompt.querySelectorAll('[data-currency-prompt-country]').forEach((node) => {
        node.textContent = target.dataset.country;
      });
      prompt.querySelectorAll('[data-currency-prompt-to]').forEach((node) => {
        node.textContent = target.dataset.currency;
      });
      prompt.querySelectorAll('[data-currency-prompt-from]').forEach((node) => {
        node.textContent = current.dataset.currency;
      });

      prompt.querySelector('[data-currency-prompt-switch]')?.addEventListener('click', () => {
        select.value = target.value;
        select.form.submit();
      });
      prompt.querySelector('[data-currency-prompt-stay]')?.addEventListener('click', () => close('stay', 90));
      prompt.querySelector('[data-currency-prompt-close]')?.addEventListener('click', () => close('later', 7));
      prompt.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') close('later', 7);
      });

      open();
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ode-localization"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.odeLocalizationBound) return;
    window.odeLocalizationBound = true;

    document.addEventListener('change', (event) => {
      const select = event.target.closest('[data-ode-localization-select]');
      if (!select || !select.form) return;
      // A country picked by hand is final: the currency prompt in
      // ode-currency-prompt stops asking.
      try {
        localStorage.setItem('ode-currency-prompt', JSON.stringify({ answer: 'picked', until: Date.now() + 365 * 86400000 }));
      } catch (error) {
        // Browsing still works with storage disabled.
      }
      select.form.submit();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ode-product-card"] && !Shopify.designMode) return;
  try {
    if (!window.odeProductCardSwatchesReady) {
    window.odeProductCardSwatchesReady = true;

    document.addEventListener('click', (event) => {
      const swatch = event.target.closest('[data-ode-card-swatch]');
      if (!swatch) return;

      const card = swatch.closest('.ode-product-card');
      if (!card) return;

      const image = card.querySelector('.ode-product-card__image img');
      const nextImageSrc = swatch.dataset.imageSrc;
      const nextImageSrcset = swatch.dataset.imageSrcset;

      if (image && nextImageSrc) {
        image.src = nextImageSrc;
        if (nextImageSrcset) image.srcset = nextImageSrcset;
        if (swatch.dataset.imageAlt) image.alt = swatch.dataset.imageAlt;
      }

      card.querySelectorAll('[data-ode-card-swatch]').forEach((item) => {
        const isSelected = item === swatch;
        item.classList.toggle('is-selected', isSelected);
        item.setAttribute('aria-pressed', String(isSelected));
      });

    });
  }
  } catch(e) { console.error(e); }
})();

})();
